var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":"","depressed":"","large":"","color":"primary","type":"submit","disabled":_vm.isValid,"loading":_vm.loginStatus_Pending},on:{"click":function($event){$event.preventDefault();return _vm.login()}}},[_vm._v(" "+_vm._s(_vm.$t("auth.login.loginButton"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }